import { AuthService } from '@anecdotes/auth-core';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { CustomerFacadeService } from '@anecdotes/data-store';

declare const delighted;

@Injectable()
export class SurveyService {
  constructor(private authService: AuthService, private customerService: CustomerFacadeService) {}

  async initAsync(): Promise<void> {
    if (localStorage.getItem('AUTO_TEST')) {
      return;
    }

    this.setScript();
    const user = await this.authService.getUserAsync();
    const customer = await firstValueFrom(this.customerService.getCurrentCustomer());

    delighted.survey({
      email: user.email,
      name: user.first_name + ' ' + user.last_name,
      createdAt: new Date(user.first_login).toISOString(),
      properties: {
        customer_name: customer.customer_name,
        account_type: customer.account_type,
      },
    });
  }

  private setScript(): void {
    const scriptBody =
      '!function(e,t,r,n){if(!e[n]){for(var a=e[n]=[],i=["survey","reset","config","init","set","get","event","identify","track","page","screen","group","alias"],c=0;c<i.length;c++){var s=i[c];a[s]=a[s]||function(e){return function(){var t=Array.prototype.slice.call(arguments);a.push([e,t])}}(s)}a.SNIPPET_VERSION="1.0.1";var o=t.createElement("script");o.type="text/javascript",o.async=!0,o.src="https://d2yyd1h5u9mauk.cloudfront.net/integrations/web/v1/library/"+r+"/"+n+".js";var p=t.getElementsByTagName("script")[0];p.parentNode.insertBefore(o,p)}}(window,document,"EwcBZ3CHpxRY7OUw","delighted");';
    const scriptNode = document.createElement('script');
    scriptNode.innerHTML = scriptBody;
    scriptNode.async = false;
    document.body.appendChild(scriptNode);
  }
}
